// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/company_summary.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AIPosture } from "./ai_posture_pb";
import { file_inventory_v1_ai_posture } from "./ai_posture_pb";
import type { CompanyLifecycle } from "./company_lifecycle_pb";
import { file_inventory_v1_company_lifecycle } from "./company_lifecycle_pb";
import type { RiskLevel } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/company_summary.proto.
 */
export const file_inventory_v1_company_summary: GenFile = /*@__PURE__*/
  fileDesc("CiJpbnZlbnRvcnkvdjEvY29tcGFueV9zdW1tYXJ5LnByb3RvEgxpbnZlbnRvcnkudjEi0QIKDkNvbXBhbnlTdW1tYXJ5EhIKCmNvbXBhbnlfaWQYASABKAkSFAoMcHJvZmlsZV9uYW1lGAIgASgJEiEKGXByb2ZpbGVfc2hvcnRfZGVzY3JpcHRpb24YAyABKAkSMQoJbGlmZWN5Y2xlGAUgASgOMh4uaW52ZW50b3J5LnYxLkNvbXBhbnlMaWZlY3ljbGUSNAoOdmFsaWRhdGVkX3Jpc2sYBiABKA4yFy5pbnZlbnRvcnkudjEuUmlza0xldmVsSACIAQESMAoPY2FsY3VsYXRlZF9yaXNrGAcgASgOMhcuaW52ZW50b3J5LnYxLlJpc2tMZXZlbBIXCg9wcm9maWxlX3dlYnNpdGUYCCABKAkSKwoKYWlfcG9zdHVyZRgJIAEoDjIXLmludmVudG9yeS52MS5BSVBvc3R1cmVCEQoPX3ZhbGlkYXRlZF9yaXNrQrsBChBjb20uaW52ZW50b3J5LnYxQhNDb21wYW55U3VtbWFyeVByb3RvUAFaQWdpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vaW52ZW50b3J5L3YxO2ludmVudG9yeXYxogIDSVhYqgIMSW52ZW50b3J5LlYxygIMSW52ZW50b3J5XFYx4gIYSW52ZW50b3J5XFYxXEdQQk1ldGFkYXRh6gINSW52ZW50b3J5OjpWMWIGcHJvdG8z", [file_inventory_v1_ai_posture, file_inventory_v1_company_lifecycle, file_inventory_v1_risk]);

/**
 * @generated from message inventory.v1.CompanySummary
 */
export type CompanySummary = Message<"inventory.v1.CompanySummary"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string profile_name = 2;
   */
  profileName: string;

  /**
   * @generated from field: string profile_short_description = 3;
   */
  profileShortDescription: string;

  /**
   * @generated from field: inventory.v1.CompanyLifecycle lifecycle = 5;
   */
  lifecycle: CompanyLifecycle;

  /**
   * @generated from field: optional inventory.v1.RiskLevel validated_risk = 6;
   */
  validatedRisk?: RiskLevel;

  /**
   * @generated from field: inventory.v1.RiskLevel calculated_risk = 7;
   */
  calculatedRisk: RiskLevel;

  /**
   * Company website, used to resolve the company logo. Empty when unknown.
   *
   * @generated from field: string profile_website = 8;
   */
  profileWebsite: string;

  /**
   * Vendor AI posture (org_company's underlying catalog company's ai_posture).
   * AI_POSTURE_UNSPECIFIED when unclassified.
   *
   * @generated from field: inventory.v1.AIPosture ai_posture = 9;
   */
  aiPosture: AIPosture;
};

/**
 * Describes the message inventory.v1.CompanySummary.
 * Use `create(CompanySummarySchema)` to create a new message.
 */
export const CompanySummarySchema: GenMessage<CompanySummary> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_summary, 0);

